import { createEnv } from "@t3-oss/env-core";
import * as z from "zod";

export const CLIENT_ENV = createEnv({
  clientPrefix: "VITE_",

  client: {
    VITE_API_URL: z.string(),
    VITE_R2_ENDPOINT: z.string(),
  },

  runtimeEnv: import.meta.env,

  emptyStringAsUndefined: true,
});
